import _ from '@lodash';
import { useDispatch } from 'react-redux';
import { Tooltip, IconButton, TableCell, Icon, Switch } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { showMessage } from 'app/store/fuse/messageSlice';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';

function TableChangeStatusButton(props) {
	const [disabled, setDisabled] = useState(false);
	const [showConfirm, setShowConfirm] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {}, [props.item]);

	const handleChangeStatus = () => {
		setDisabled(true);
		setShowConfirm(false);
	};

	return (
		<TableCell className="w-auto text-center" padding="none">
			<Tooltip title="Státusz">
				<Switch checked disabled={disabled} onChange={() => setShowConfirm(true)} inputProps={{ 'aria-label': 'secondary checkbox' }} />
			</Tooltip>
			<ConfirmDialog show={showConfirm} title="Státusz" description="Biztosan átállítja a kiválasztott kérdés státuszát?" onYes={() => handleChangeStatus()} onClose={() => setShowConfirm(false)} />
		</TableCell>
	);
}

export default TableChangeStatusButton;
